import { Injectable } from '@angular/core';
import { Apollo } from 'apollo-angular';
import { Observable } from 'rxjs/Observable';
import { map } from 'rxjs/operators';
import { dealersQuery, getDealersByCompanyId } from '../../../graph-ql/queries';
import { DealerResponse } from '../../models/dealer/dealer.response';

@Injectable()
export class DealerService {

  constructor(public apollo: Apollo) {
  }

  dealersQuery$(page: number, itemPerPage: number): Observable<DealerResponse> {
    return this.apollo.query<DealerResponse>({
      query: dealersQuery,
      variables: {
        dealerInput: {
          paginationInput: {
            page,
            itemPerPage
          }
        }
      }
    })
      .pipe(map(result => {

        if (!result.data['getDealers']) {
          return new DealerResponse([], 0);
        }

        return new DealerResponse(result.data['getDealers']['dealers'],
          result.data['getDealers']['totalCount']
        );
      }
      ));
  }

  getDealersByCompanyId$(id: string): Observable<any> {
    return this.apollo.query<any>({
      query: getDealersByCompanyId,
      variables: {
        input: id
      }
    }).pipe(map(result => {
      return result.data['getDealersByCompanyId'];
    }));
  }
}
